import {t} from 'shared/core';
import {Link} from 'react-router-dom';
import {ActionLink} from 'shared/components';
import {observer} from 'mobx-react';
import Layout from 'shared/components/layouts/Layout';

const BackLink = observer(({children, onBackClick, ...rest}) => {
  if (onBackClick) {
    return (
      <ActionLink onClick={onBackClick} {...rest}>{children}</ActionLink>
    );

  } else {
    return (
      <Link {...rest}>{children}</Link>
    );
  }
});

const BackToIndex = ({path = '/', title = t('components.navigation.Back'), hasTitle = false, nested, onBackClick}) => {
  return (
    <div className={nested ? '' : 'pt3'}>
      <Layout>
        <div className={`BackToIndex ${hasTitle ? 'BackToIndex-hasTitle' : ''}`}>
          <BackLink to={path} onBackClick={onBackClick} className='flex items-center HoverAnimation-trigger--image jumbo'>
            <i className='material-icons' style={{fontSize: '24px'}}>{'keyboard_arrow_left'}</i>
            <span className='align-middle'>
              {title}
            </span>
          </BackLink>
        </div>
      </Layout>
    </div>
  );
};

export default BackToIndex;
